module.exports = "/images/vendor/flag-icon-css/flags/4x3/je.svg?e0932aed817435f70cf058dd3261ae1c";